
(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const sections = document.querySelectorAll('.mt-womo-faq[data-section-id]');
    if (!sections.length) return;

    sections.forEach((section) => {
      const answers = section.querySelectorAll('.mt-womo-faq__answer');
      answers.forEach((answer) => {
        if (answer.hasAttribute('hidden')) {
          answer.style.height = '0px';
        } else {
          answer.style.height = 'auto';
          answer.classList.add('is-open');
        }

        answer.addEventListener('transitionend', (e) => {
          if (e.propertyName !== 'height') return;
          if (answer.classList.contains('is-open')) {
            answer.style.height = 'auto';
          } else {
            answer.hidden = true;
          }
        });
      });

      section.addEventListener('click', (e) => {
        const btn = e.target && e.target.closest('.mt-womo-faq__question');
        if (!btn || !section.contains(btn)) return;

        const answerId = btn.getAttribute('aria-controls');
        if (!answerId) return;

        const answer = section.querySelector('#' + CSS.escape(answerId));
        if (!answer) return;

        const isExpanded = btn.getAttribute('aria-expanded') === 'true';
        const nextExpanded = !isExpanded;

        btn.setAttribute('aria-expanded', String(nextExpanded));

        if (nextExpanded) {
          answer.hidden = false;
          answer.classList.add('is-open');
          answer.style.height = '0px';
          const targetHeight = answer.scrollHeight;
          requestAnimationFrame(() => {
            answer.style.height = targetHeight + 'px';
          });
        } else {
          const currentHeight = answer.scrollHeight;
          answer.style.height = currentHeight + 'px';
          answer.offsetHeight;
          answer.classList.remove('is-open');
          requestAnimationFrame(() => {
            answer.style.height = '0px';
          });
        }
      });
    });
  }
})();

